require('./helpers/bundle-manifest').register(JSON.parse("{\"ftwPB\":\"loader.js\",\"iUvvd\":\"frontend.340ff1a4.js\"}"));